var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconCircleChevronRightFill = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 0.666748C4.45001 0.666748 1.16667 3.95008 1.16667 8.00008C1.16667 12.0501 4.45001 15.3334 8.5 15.3334C12.55 15.3334 15.8333 12.0501 15.8333 8.00008C15.8333 3.95008 12.55 0.666748 8.5 0.666748ZM7.02867 5.80475C6.90723 5.67901 6.84004 5.51061 6.84156 5.33581C6.84307 5.16102 6.91319 4.99381 7.03679 4.8702C7.1604 4.7466 7.32761 4.67648 7.5024 4.67496C7.6772 4.67345 7.8456 4.74064 7.97134 4.86208L10.638 7.52875C10.763 7.65377 10.8332 7.8233 10.8332 8.00008C10.8332 8.17686 10.763 8.3464 10.638 8.47141L7.97134 11.1381C7.8456 11.2595 7.6772 11.3267 7.5024 11.3252C7.32761 11.3237 7.1604 11.2536 7.03679 11.13C6.91319 11.0064 6.84307 10.8391 6.84156 10.6643C6.84004 10.4896 6.90723 10.3211 7.02867 10.1954L9.224 8.00008L7.02867 5.80475Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconCircleChevronRightFill, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_circle-chevron-right-fill.e6d23776.svg";
export { ForwardRef as ReactComponent };